export function stopEvent(e: React.SyntheticEvent) {
  e.preventDefault();
  e.stopPropagation();
}
// Whenever the list of options changes, delete any local draft edits that belong to options that no longer exist.
export function pruneRecord<T>(
  record: Record<string, T>,
  allowedKeys: Set<string>,
): Record<string, T> {
  return Object.entries(record).reduce<Record<string, T>>((acc, [key, value]) => {
    if (allowedKeys.has(key)) acc[key] = value;
    return acc;
  }, {});
}

export function removeKey<T>(record: Record<string, T>, key: string): Record<string, T> {
  if (!(key in record)) return record;
  const next = { ...record };
  delete next[key];
  return next;
}

export const normalizeText = (value: string) => value.trim().toLocaleLowerCase();
